<template>
  <transition
    class="loading"
    name="loading-fade"
    @after-leave="handleAfterLeave"
  >
    <div
      v-show="visible"
      class="loading-mask"
      :class="[customClass, { 'is-fullscreen': fullscreen }]"
    >
      <div class="loading-spiner">
        <div class="loading-wrap">
          <p
            class="loading-item"
            v-for="i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
          ></p>
        </div>
        <p v-if="text" class="loading-text">{{ text }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
/*eslint-disable*/
export default {
    props:{
        visible:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            text: '',
            fullscreen: true,
            customClass: ''
        };
    },
    methods: {
      handleAfterLeave() {
        this.$emit('after-leave');
      },
      setText(text) {
        this.text = text;
      }
    }
  };
</script>
<style lang=scss scoped>
  @import '../../../assets/css/mixin';
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f1f1f1;
    z-index: 200;
    transition: all 0.3s;
  }

  .loading-mask {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: rgba(0,0,0,.5);
    font-size: rem(28px);
  }
  .loading-spiner {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: rem(40px);
    background: rgba(0,0,0,.7);
    border-radius: rem(20px)
  }
  .loading-text {
    padding-top: rem(30px);
    color: #fff;
  }
  .loading-wrap {
    $centerRadius: 1em;
    $itemWidth: .6em;
    $itemHeight: .15em;
    $width: $centerRadius + $itemWidth * 2;
    $height: $width;
    width: $width;
    height: $height;
    position: relative;
    .loading-item {
        width: $itemWidth;
        height: $itemHeight;
        margin-top: $itemHeight / 2 * -1;
        margin-left: $centerRadius / 2;
        top: 50%;
        left: 50%;
        position: absolute;
        background-color: #fff;
        transform-origin: ($centerRadius / 2 * -1) ($itemHeight / 2);
        border-radius: 1px;
        @for $i from 1 through 12 {
          &:nth-child(#{$i}) {
              transform: rotate(($i - 1) * 30deg);
              animation: loading-item 1s linear infinite #{-1 + $i / 12}s;
          }
        }
        @at-root {
          @keyframes loading-item{
            0% {
                opacity: 1;
            }
            @for $i from 1 through 11 {
                #{$i / 12 * 100}% {
                    opacity: 1 - $i / 12;
                }
            }
            100% {
                opacity: 1;
            }
          }
        }
    }
  }
</style>
